import React from 'react'
import { Link } from 'react-router-dom'

export default function Land() {
  return (
    <div>

<section className="text-gray-600 body-font">
  <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
    <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
      <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">Trade & Share: Connect with the Community
        <br className="hidden lg:inline-block"/>for Your Buying and Selling Needs
      </h1>
      <p className="mb-8 leading-relaxed">Looking for a platform to buy, sell, or trade items like books, electronics, and more? Trade & Share is your go-to destination. Connect with others in the community to discover great deals, share items you no longer need, and find unique treasures. Join our community today and unlock a world of possibilities!</p>
      <div className="flex justify-center">
        <Link to={"/login"}>
        <button className="inline-flex text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">Login To Explore Listings</button>
        </Link>
      </div>
    </div>
    <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
      <img className="object-cover object-center rounded" alt="hero" src="https://media.istockphoto.com/id/1335694105/vector/shaking-hands.jpg?s=612x612&w=0&k=20&c=04q0HWBX4NtoO8ooy_mqhcF9OsvN6tteCU_ZHNpvnCA="/>
    </div>
  </div>
</section>




<section className="text-gray-600 body-font">
  <div className="container px-5 py-24 mx-auto flex flex-wrap">
  <div className="flex w-full mb-20 flex-wrap">
  <h1 className="sm:text-3xl text-2xl font-medium title-font text-gray-900 lg:w-1/3 lg:mb-0 mb-4">Welcome to HostelShare</h1>
  <p className="lg:pl-6 lg:w-2/3 mx-auto leading-relaxed text-base">Find and share resources like books, electronics, and more within your hostel community. Join HostelShare today and connect with fellow residents to make sharing easy and convenient. From textbooks to gadgets, discover what's available and share what you have with others.</p>
</div>

    <div className="flex flex-wrap md:-m-2 -m-1">
      <div className="flex flex-wrap w-1/2">
        <div className="md:p-2 p-1 w-1/2">
          <img alt="gallery" className="w-full object-cover h-full object-center block" src="https://source.unsplash.com/featured/?books&300x200"/>
        </div>
        <div className="md:p-2 p-1 w-1/2">
          <img alt="gallery" className="w-full object-cover h-full object-center block" src="https://source.unsplash.com/featured/?electronics&400x250"/>
        </div>
        <div className="md:p-2 p-1 w-full">
          <img alt="gallery" className="w-full h-full object-cover object-center block" src="https://source.unsplash.com/featured/?books&500x300"/>
        </div>
      </div>
      <div className="flex flex-wrap w-1/2">
        <div className="md:p-2 p-1 w-full">
          <img alt="gallery" className="w-full h-full object-cover object-center block" src="https://source.unsplash.com/featured/?books&600x350"/>
        </div>
        <div className="md:p-2 p-1 w-1/2">
          <img alt="gallery" className="w-full object-cover h-full object-center block" src="https://source.unsplash.com/featured/?electronics&700x400"/>
        </div>
        <div className="md:p-2 p-1 w-1/2">
          <img alt="gallery" className="w-full object-cover h-full object-center block" src="https://source.unsplash.com/featured/?books&800x450"/>
        </div>
      </div>
    </div>
  </div>
</section>




<section className="text-gray-600 body-font">
  <div className="container px-5 py-24 mx-auto">
    <div className="flex flex-wrap -m-4">
      <div className="lg:w-1/3 lg:mb-0 mb-6 p-4">
        <div className="h-full text-center">
          <img alt="testimonial" className="w-20 h-20 mb-8 object-cover object-center rounded-full inline-block border-2 border-gray-200 bg-gray-100" src="https://cdn.britannica.com/42/155442-050-AB85E00E/Mother-Teresa.jpg"/>
          <p className="leading-relaxed">Spread love everywhere you go. Let no one ever come to you without leaving happier.</p>
          <span className="inline-block h-1 w-10 rounded bg-indigo-500 mt-6 mb-4"></span>
          <h2 className="text-gray-900 font-medium title-font tracking-wider text-sm">Mother Teresa</h2>
          
        </div>
      </div>
      <div className="lg:w-1/3 lg:mb-0 mb-6 p-4">
        <div className="h-full text-center">
          <img alt="testimonial" className="w-20 h-20 mb-8 object-cover object-center rounded-full inline-block border-2 border-gray-200 bg-gray-100" src="https://cdn.britannica.com/91/82291-050-EB7A276A/Mohandas-K-Gandhi-leader-Mahatma-Indian.jpg?w=400&h=300&c=crop"/>
          <p className="leading-relaxed">The best way to find yourself is to lose yourself in the service of others.</p>
          <span className="inline-block h-1 w-10 rounded bg-indigo-500 mt-6 mb-4"></span>
          <h2 className="text-gray-900 font-medium title-font tracking-wider text-sm">Mahatma Gandhi</h2>
          
        </div>
      </div>
      <div className="lg:w-1/3 lg:mb-0 p-4">
        <div className="h-full text-center">
          <img alt="testimonial" className="w-20 h-20 mb-8 object-cover object-center rounded-full inline-block border-2 border-gray-200 bg-gray-100" src="https://cdn.britannica.com/54/9454-050-D39631E8/Albert-Schweitzer-photograph-Yousuf-Karsh.jpg"/>
          <p className="leading-relaxed">The purpose of human life is to serve, and to show compassion and the will to help others.</p>
          <span className="inline-block h-1 w-10 rounded bg-indigo-500 mt-6 mb-4"></span>
          <h2 className="text-gray-900 font-medium title-font tracking-wider text-sm">Albert Schweitzer</h2>

        </div>
      </div>
    </div>
  </div>
</section>


    </div>
  )
}
